<template>
	<div class="chooseLocationBody" :style="{'width':width+'px'}">
		<div>
			<el-select 
				v-model="address" 
				size="small" value-key="id" 
				style="width: 100%;" 
				filterable remote 
				placeholder="请输入地点查询" 
				:remote-method="remoteMethod" 
				:loading="loading" 
				@change="pickAddress($event)">
			    <el-option v-for="(item,index) in options" :key="index" :label="item.name" :value="item">
					<span style="float: left">{{ item.name }}</span>
					<span style="float: right; color: #8492a6; font-size: 13px">{{ item.cityname+item.adname+item.address }}</span>
				</el-option>
			</el-select>
		</div>
		
		<div id="chooseLocationMap"></div>
	</div>
</template>

<script>
	let that;
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {mapKey} from '@/unit/util.js'
	export default {
		name:"chooseLocation",
		data() {
			return {
				mapKey:mapKey,
				loading:false,
				address:'',
				options:[],
				mapContent:null,
				mapMarker:null
			};
		},
		props:{
			width:{
				typeof:[Number,String],
				default:600
			},
			location:{
				typeof:[Object,String],
				default:''
			},
		},
		created() {
			that = this;
		},
		destroyed() {
			// 销毁地图
			if(this.mapContent) this.mapContent.destroy();
		},
		mounted() {
			this.initMap()
		},
		watch:{
			location:function(val){
				let position = new AMap.LngLat(val.lng,val.lat)
				this.mapContent.setCenter(position,true,)
				this.mapMarker =  new AMap.Marker({
					position: position, 
					label:{
					  content:val.name,
					  direction:'top'
					}
				});
				this.mapContent.add(this.mapMarker)
			}
		},
		methods:{
			pickAddress(e){
				this.$emit('pickAddress',e)
				if(this.mapMarker) this.mapContent.remove(this.mapMarker);
				let position = new AMap.LngLat(e.location.lng,e.location.lat)
				this.mapContent.setCenter(position,true,)
				this.mapMarker =  new AMap.Marker({
					position: position, 
					label:{
					  content:e.cityname+e.adname+e.address,
					  direction:'top'
					}
				});
				this.mapContent.add(this.mapMarker)
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true
					this.mapPlaceSearh(query)
				} else {
					this.options = [];
				}
			  },
			initMap() {
				AMapLoader.load({
					"key": this.mapKey,
					"plugins": ["AMap.PlaceSearch"],
				}).then((AMap) => {
					// 初始化地图
					this.mapContent = new AMap.Map('chooseLocationMap', {
						viewMode: "2D", //  是否为3D地图模式
						zoom: 15, // 初始化地图级别
					});
				}).catch(e => {
					console.log('地图加载出错-----选地址组件',e);
				});
			},
			mapPlaceSearh(text){
				AMap.plugin("AMap.PlaceSearch", function () {
					var placeSearch = new AMap.PlaceSearch({
						pageSize:20,
						extensions:'all'
					});
					placeSearch.search(text, function (status, result) {
						that.loading = false
						console.log(result)
						if(Object.keys(result).length>0){
							that.options = result.poiList.pois
						}else{
							that.options = []
						}
						
					});
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.chooseLocationBody{
		width: 100%;
		position: relative;
		z-index: 999;
	}
	#chooseLocationMap{
		width: 100%;
		margin-top: 18px;
		height: 400px;
	}
</style>